<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600"
  >
    <v-card>
      <v-toolbar
        dark
      >
        <v-toolbar-title>
          Create GTPS Software Update
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <div class="mb-5">
          <i>Enter the path to the update files then click the validate check mark.  The update manifest must be verified before creating the update record.</i>
        </div>
        <v-text-field
          v-model="updatePath"
          label="update path"
          outlined
          :append-icon="getIcon()"
          @click:append="validate"
          @input="pathChanged"
          :loading="validating"
        >
        </v-text-field>
        <div v-if="errorText" style="color: darkred">
          <i>{{errorText}}</i>
        </div>
        <div v-if="validated" style="color: darkgreen">
          <i>A manifest.json file has been found and verified at the specified path. The update will have version <b>{{manifest.version.semantic}}</b>.  Click CONFIRM to create the update.  </i>
        </div>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="indigo" class="white--text" @click="onConfirmClick()" v-if="validated">Confirm</v-btn>
        <v-btn color="grey lighten-1" @click="onCancelClick()">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
  },

  data() {
    return {
      updatePath: '',
      errorText: null,
      validating: false,
      validated: false,
      manifest: null,
    };
  },

  methods: {
    getIcon() {
      if (this.errorText) {
        return 'error';
      }

      if (this.validated) {
        return 'check_circle';
      }

      return 'check_circle_outline';
    },

    onCancelClick() {
      this.updatePath = '';
      this.errorText = null;
      this.validating = false;
      this.validated = false;
      this.manifest = null;

      this.$emit('close');
    },

    pathChanged() {
      this.errorText = null;
      this.validated = false;
    },

    onConfirmClick() {
      const options = {
        method: 'POST',
        url: '/create/gtps_update/v1',
        data: {
          version: this.manifest.version,
          prerequisite: this.manifest.prerequisites.require,
          family: this.manifest.family || 'aligner',
          path: this.updatePath,
        },
      };

      this.axios(options)
        .then((res) => {
          this.updatePath = '';
          this.errorText = null;
          this.validating = false;
          this.validated = false;
          this.manifest = null;

          this.$emit('close');
        });
    },

    validate() {
      const options = {
        method: 'POST',
        url: '/validate_gtps_software_update_at_path/v1',
        data: {
          updatePath: this.updatePath,
        },
      };

      this.validating = true;

      this.axios(options)
        .then((res) => {
          this.errorText = null;
          this.validating = false;
          this.validated = true;
          this.manifest = res.data;
        })
        .catch((err) => {
          console.error(`--- validation error ${err.response.status}, ${err.response.data}`);
          this.validating = false;
          this.validated = false;
          this.manifest = null;
          switch (err.response.data) {
            case 'MANIFEST_NOT_FOUND':
              this.errorText = 'A manifest.json file was not found at the specified path.  Verify that the path you entered is correct or try a different path.';
              break;
          }
        });
    },
  },
};
</script>
